import { sectionAccentColor } from '../../../shared/ui/editorAccents';
import { panelGroupLabelStyle } from '../../../shared/ui/panelHeading';

/**
 * Intitulé d'un sous-groupe de réglages, dans les panneaux de box partagées.
 * Tracé comme les groupes de modèles du panel de la carte (cf. InfoCardBox).
 */
const FieldGroupLabel = ({ children }) => (
  <div style={{ ...panelGroupLabelStyle(sectionAccentColor(children)), marginTop: 8 }}>
    {children}
  </div>
);

export default FieldGroupLabel;
